import { render, staticRenderFns } from "./ImageToImageProperties.vue?vue&type=template&id=565c2eac"
import script from "./ImageToImageProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageToImageProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports